import { CoinHistorySearchForm } from './CoinHistorySearchForm'
import { withCoinHistorySearchForm } from './withCoinHistorySearchForm'

const ConnectedCoinHistorySearchForm = withCoinHistorySearchForm(
  CoinHistorySearchForm
)

export { ConnectedCoinHistorySearchForm as CoinHistorySearchForm }
